import React, { useState } from "react";
import {
  FaBatteryThreeQuarters,
  FaBolt,
  FaShieldAlt,
  FaBroadcastTower,
  FaTachometerAlt,
  FaLeaf,
  FaRedoAlt,
  FaCheckCircle,
  FaArrowRight,
  FaMagic,
  FaFileAlt,
  FaPhoneAlt,
  FaCoins
} from "react-icons/fa";

import { MdSecurity } from "react-icons/md";
import brochurePDF from "../assets/brochure.pdf";

import Navbar from "./NavBar";
import electric from "../assets/electricbus1.png";

const ElectricBusProductPage = () => {
  const [activeFeature, setActiveFeature] = useState(0);

  const features = [
    {
      id: 0,
      title: "353 kWh CATL Battery",
      shortTitle: "Battery",
      description: "High-density lithium battery system engineered for superior thermal stability.",
      details: "Utilizing advanced Liquid Cooling Technology to maintain optimum cell temperatures, ensuring uninterrupted commercial operations even under extreme climate conditions.",
      icon: <FaBatteryThreeQuarters className="w-5 h-5" />,
    },
    {
      id: 1,
      title: "300+ KM Driving Range",
      shortTitle: "Range",
      description: "Optimized energy management system delivers exceptional intercity driving range.",
      details: "Powered by smart power-allocation algorithms that adjust real-time consumption based on passenger payload, topology, and driving style.",
      icon: <FaTachometerAlt className="w-5 h-5" />,
    },
    {
      id: 2,
      title: "Dual Gun Fast Charging",
      shortTitle: "Charging",
      description: "Advanced DC dual-gun charging architecture minimizes fleet downtime.",
      details: "Supports parallel fast charging inputs, taking the massive 353 kWh pack from 20% to 80% state-of-charge in less than 90 minutes safely.",
      icon:<FaBolt className="w-5 h-5" />,
    },
    {
      id: 3,
      title: "Smart Fleet Intelligence",
      shortTitle: "Telematics",
      description: "Integrated AI-powered telematics for live analytics and remote fleet management.",
      details: "Provides dispatchers with continuous over-the-air (OTA) cloud diagnostics, real-time battery health mapping, and geofencing systems.",
      icon: <FaBroadcastTower className="w-5 h-5" />,
    },
    {
      id: 4,
      title: "Regenerative Braking",
      shortTitle: "Regen",
      description: "Captures kinetic braking energy and converts it back into usable battery power.",
      details: "An intelligent multi-stage braking recovery setup reduces brake-pad wear by up to 45% while feeding range back into the cells dynamically.",
      icon: <FaRedoAlt className="w-5 h-5" />,
    },
    {
      id: 5,
      title: "Safety Architecture",
      shortTitle: "Safety",
      description: "Reinforced chassis built with ECAS suspension, ABS, ADAS, and smart defense.",
      details: "Equipped with Forward Collision Warning, Lane Departure Prevention, and an automatic Fire Detection & Suppression System (FDSS) guarding the entire powertrain.",
      icon: <FaShieldAlt className="w-5 h-5" />,
    },
  ];

  const specs = [
    { title: "Battery Capacity", value: "353 kWh CATL LFP Battery" },
    { title: "Operational Range", value: "300+ KM Per Charge" },
    { title: "Charging Time", value: "Approx. 1.5 Hours (Dual DC)" },
    { title: "Passenger Capacity", value: "45+1 Luxury Reclining Seats" },
    { title: "Suspension System", value: "Electronic Air Suspension (ECAS)" },
    { title: "Safety Suites", value: "ADAS + ABS + EBS + FDSS Protection" },
  ];

  const stats = [
    { value: "353", unit: "kWh", label: "CATL Energy Pack" },
    { value: "300+", unit: "KM", label: "Certified Range" },
    { value: "0%", unit: "CO₂", label: "Tailpipe Emissions" },
    { value: "1.5", unit: "Hrs", label: "Rapid Recharge" },
  ];

  return (
    <div className="bg-[#f8faf9] min-h-screen text-slate-900 font-sans selection:bg-emerald-500 selection:text-white antialiased">
      <Navbar />

{/* TOP ANNOUNCEMENT BAR */}
<div className="w-full bg-gradient-to-r from-emerald-600 via-green-500 to-emerald-600 text-white py-2 overflow-hidden relative border-b border-emerald-400/30">

  {/* Glow Effect */}
  <div className="absolute inset-0 bg-white/5 backdrop-blur-sm" />

  {/* Scrolling Text */}
  <div className="relative flex whitespace-nowrap animate-marquee">
    
    <div className="flex items-center gap-12 px-6 text-xs sm:text-sm font-semibold tracking-wide uppercase">
      
      <span className="flex items-center gap-2">
        ⚡ India’s First Electric Bus launched with BC5 CATL Batteries
      </span>

      <span className="opacity-50">•</span>

      <span>
        353 kWh Advanced Energy Platform
      </span>

      <span className="opacity-50">•</span>

      <span>
        300+ KM Certified Driving Range
      </span>

      <span className="opacity-50">•</span>

      <span>
        Intelligent EV Fleet Technology
      </span>

      <span className="opacity-50">•</span>

    </div>

    {/* Duplicate for smooth infinite scroll */}
    <div className="flex items-center gap-12 px-6 text-xs sm:text-sm font-semibold tracking-wide uppercase">
      
      <span className="flex items-center gap-2">
        ⚡ India’s First Electric Bus launched with BC5 CATL Batteries
      </span>

      <span className="opacity-50">•</span>

      <span>
        353 kWh Advanced Energy Platform
      </span>

      <span className="opacity-50">•</span>

      <span>
        300+ KM Certified Driving Range
      </span>

      <span className="opacity-50">•</span>

      <span>
        Intelligent EV Fleet Technology
      </span>

      <span className="opacity-50">•</span>

    </div>

  </div>
</div>
      {/* HERO SECTION */}
      <section className="relative pt-20 pb-12 lg:pt-32 lg:pb-24 px-4 sm:px-6 overflow-hidden">
        {/* Ambient background blur elements */}
        <div className="absolute top-0 left-1/4 w-72 h-72 sm:w-[500px] sm:h-[500px] bg-emerald-200/30 rounded-full blur-[60px] sm:blur-[120px] pointer-events-none" />
        <div className="absolute bottom-0 right-10 w-64 h-64 sm:w-[400px] sm:h-[400px] bg-teal-100/40 rounded-full blur-[50px] sm:blur-[100px] pointer-events-none" />

        <div className="max-w-7xl mx-auto relative z-10">
          <div className="flex flex-col lg:grid lg:grid-cols-12 gap-10 lg:gap-8 items-center">
            
            {/* HERO LEFT / TOP CONTENT */}
            <div className="w-full lg:col-span-5 text-center lg:text-left space-y-5 sm:space-y-6 order-1">
              <div className="inline-flex items-center gap-2 bg-emerald-100/80 backdrop-blur-md border border-emerald-200/50 text-emerald-800 px-3.5 py-1.5 rounded-full text-[11px] sm:text-xs font-semibold uppercase tracking-wider shadow-sm">
               <FaLeaf className="w-3.5 h-3.5 text-emerald-600 shrink-0" />
                Zero Emission. Maximum Efficiency.
              </div>

              <h1 className="text-3xl sm:text-5xl lg:text-6xl font-extrabold tracking-tight text-slate-900 leading-[1.15] lg:leading-[1.1]">
                The Future of <br className="hidden lg:block"/>
                <span className="bg-gradient-to-r from-emerald-600 to-teal-600 bg-clip-text text-transparent">
                  Commercial Transit
                </span>
              </h1>

              <p className="text-sm sm:text-base lg:text-lg text-slate-600 max-w-xl mx-auto lg:mx-0 leading-relaxed font-normal">
                Redefining sustainable heavy transportation with tier-one battery chemistry, intelligent fleet telematics, and premium passenger comforts engineered for scalable transit infrastructure.
              </p>

              <div className="flex flex-col sm:flex-row justify-center lg:justify-start gap-3 sm:gap-4 pt-2">
                <button className="group bg-slate-900 hover:bg-emerald-600 text-white px-6 sm:px-8 py-3.5 sm:py-4 rounded-xl font-medium text-sm sm:text-base transition-all duration-300 shadow-lg shadow-slate-900/10 flex items-center justify-center gap-2">
                  Book Fleet Demo
<FaArrowRight className="w-4 h-4 transition-transform group-hover:translate-x-1" />                </button>

                <button onClick={() => {  
    const link = document.createElement("a");
    link.href = brochurePDF;
    link.download = "Electric-Bus-Brochure.pdf";
    link.click();
  }} className="group border border-slate-200 bg-white hover:bg-slate-50 text-slate-700 px-6 sm:px-8 py-3.5 sm:py-4 rounded-xl font-medium text-sm sm:text-base transition-all duration-300 flex items-center justify-center gap-2">
             <FaFileAlt className="w-4 h-4 text-slate-400" />
                  Technical Brochure
                </button>
              </div>
            </div>

            {/* HERO RIGHT / BOTTOM IMAGE */}
            <div className="w-full lg:col-span-7 relative flex justify-center items-center mt-4 lg:mt-0 order-2">
              <div className="absolute w-[90%] sm:w-[85%] aspect-square bg-gradient-to-tr from-emerald-100 to-teal-50 rounded-[24px] sm:rounded-[40px] rotate-3 sm:rotate-6 scale-95 opacity-70 -z-10" />
              <div className="absolute w-[85%] sm:w-[80%] aspect-square bg-white rounded-[24px] sm:rounded-[40px] -rotate-3 -z-10 shadow-xl border border-slate-100" />
              
              <div className="p-2 sm:p-6 md:p-12 w-full max-w-[550px] lg:max-w-none">
                <img
                  src={electric}
                  alt="Electric Coach Product Showcase"
                  className="w-full h-auto max-h-[260px] sm:max-h-[380px] lg:max-h-[420px] object-contain drop-shadow-[0_15px_25px_rgba(16,185,129,0.12)]"
                />
              </div>
            </div>

          </div>
        </div>
      </section>

      {/* STATS STRIP SECTION */}
      <section className="pb-16 px-4 sm:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="bg-white rounded-2xl sm:rounded-3xl border border-slate-100 shadow-xl shadow-slate-200/40 p-5 sm:p-8 grid grid-cols-2 lg:grid-cols-4 gap-y-6 gap-x-2 sm:gap-x-4">
            {stats.map((item, i) => (
              <div key={i} className="text-center px-2 lg:border-l lg:border-slate-100 lg:first:border-l-0 space-y-0.5">
                <div className="flex items-baseline justify-center text-slate-900 font-extrabold tracking-tight">
                  <span className="text-2xl sm:text-4xl lg:text-5xl bg-gradient-to-b from-slate-900 to-slate-700 bg-clip-text text-transparent">{item.value}</span>
                  <span className="text-base sm:text-xl text-emerald-600 ml-0.5 font-semibold">{item.unit}</span>
                </div>
                <p className="text-[10px] sm:text-xs text-slate-500 font-medium tracking-wide uppercase">{item.label}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* FEATURES INTERACTIVE SECTION */}
      <section className="py-16 sm:py-20 bg-slate-50 border-y border-slate-200/60 px-4 sm:px-6">
        <div className="max-w-7xl mx-auto">
          
          <div className="max-w-3xl mx-auto text-center mb-10 sm:mb-16 space-y-3">
            <h2 className="text-2xl sm:text-4xl font-extrabold tracking-tight text-slate-900">
              Advanced Technology Architecture
            </h2>
            <p className="text-slate-600 text-sm sm:text-base md:text-lg">
              Engineered cleanly from the ground up with smart component layouts optimizing efficiency and fleet runtime.
            </p>
          </div>

          <div className="flex flex-col lg:grid lg:grid-cols-12 gap-6 lg:gap-12 items-stretch">
            
            {/* HORIZONTAL SCROLL ON MOBILE, VERTICAL MENU ON DESKTOP */}
            <div className="w-full lg:col-span-5 flex lg:flex-col gap-2 overflow-x-auto pb-3 lg:pb-0 scrollbar-none snap-x snap-mandatory">
              {features.map((feature, idx) => (
                <button
                  key={feature.id}
                  onClick={() => setActiveFeature(idx)}
                  className={`snap-center shrink-0 min-w-[140px] sm:min-w-[220px] lg:w-full text-left rounded-xl sm:rounded-2xl p-3 sm:p-4 transition-all duration-300 border flex flex-col lg:flex-row gap-2 lg:gap-4 items-center lg:items-start ${
                    activeFeature === idx
                      ? "bg-white text-slate-900 border-emerald-500 shadow-md lg:translate-x-2"
                      : "bg-white/50 lg:bg-transparent hover:bg-slate-100 text-slate-700 border-slate-200/60 lg:border-transparent"
                  }`}
                >
                  <div className={`p-2 rounded-lg sm:rounded-xl shrink-0 ${
                    activeFeature === idx ? "bg-emerald-600 text-white" : "bg-slate-200 text-slate-600"
                  }`}>
                    {feature.icon}
                  </div>
                  <div className="text-center lg:text-left">
                    {/* Shows shorter titles on mobile layout to save space */}
                    <h3 className="font-bold text-xs sm:text-sm lg:text-base text-slate-900 mb-0.5 hidden sm:block">{feature.title}</h3>
                    <h3 className="font-bold text-xs text-slate-900 mb-0.5 sm:hidden">{feature.shortTitle}</h3>
                    <p className="text-xs text-slate-500 line-clamp-1 hidden lg:block">{feature.description}</p>
                  </div>
                </button>
              ))}
            </div>

            {/* SHOWCASE DISPLAY TERMINAL */}
            <div className="w-full lg:col-span-7">
              <div className="bg-white rounded-2xl sm:rounded-[2rem] p-6 sm:p-10 border border-slate-200/80 shadow-xl shadow-slate-200/50 h-full flex flex-col justify-between relative overflow-hidden">
                <div className="absolute top-0 right-0 w-64 h-64 bg-gradient-to-bl from-emerald-100/30 to-teal-50/10 rounded-full blur-3xl pointer-events-none" />
                
                <div className="space-y-6 sm:space-y-8 relative z-10">
                  <div className="flex items-center justify-between">
                    <div className="bg-emerald-50 text-emerald-600 w-12 h-12 sm:w-14 sm:h-14 rounded-xl sm:rounded-2xl flex items-center justify-center shadow-inner border border-emerald-100">
                      {features[activeFeature].icon}
                    </div>
                    <span className="inline-flex items-center gap-1.5 bg-slate-50 text-slate-500 px-2.5 py-1 rounded-md text-[10px] sm:text-xs font-semibold uppercase tracking-wider border border-slate-100">
                    <FaMagic className="w-3 h-3 text-emerald-500" /> Module 0{activeFeature + 1}
                    </span>
                  </div>

                  <div className="space-y-3">
                    <h3 className="text-xl sm:text-3xl font-extrabold text-slate-900 tracking-tight">
                      {features[activeFeature].title}
                    </h3>
                    <p className="text-sm sm:text-base md:text-lg text-slate-700 leading-relaxed font-medium">
                      {features[activeFeature].description}
                    </p>
                    <p className="text-xs sm:text-sm text-slate-500 leading-relaxed pt-3 border-t border-slate-100">
                      {features[activeFeature].details}
                    </p>
                  </div>
                </div>

                <div className="mt-6 sm:mt-8 pt-4 sm:pt-6 border-t border-slate-100 grid gap-3 sm:grid-cols-2 relative z-10">
                  <div className="flex gap-2 items-start">
<FaCheckCircle className="text-emerald-500 w-4 h-4 shrink-0 mt-0.5" />                    <div>
                      <h4 className="font-bold text-[10px] sm:text-xs text-slate-900 uppercase tracking-wider">Homologation</h4>
                      <p className="text-[11px] text-slate-500">Fully certified under global EV rules.</p>
                    </div>
                  </div>
                  <div className="flex gap-2 items-start">
                  <MdSecurity className="text-emerald-500 w-4 h-4 shrink-0 mt-0.5" />
                    <div>
                      <h4 className="font-bold text-[10px] sm:text-xs text-slate-900 uppercase tracking-wider">Warranty Shield</h4>
                      <p className="text-[11px] text-slate-500">8-Year / 500,000 KM battery coverage.</p>
                    </div>
                  </div>
                </div>

              </div>
            </div>
          </div>

        </div>
      </section>

      {/* TECHNICAL SPECIFICATIONS GRID */}
      <section className="py-16 sm:py-24 px-4 sm:px-6 bg-slate-950 text-white relative overflow-hidden">
        <div className="absolute inset-0 bg-[radial-gradient(#334155_1px,transparent_1px)] [background-size:16px_16px] opacity-20" />
        
        <div className="max-w-5xl mx-auto relative z-10">
          <div className="text-center mb-10 sm:mb-16 space-y-2">
            <h2 className="text-2xl sm:text-4xl font-extrabold tracking-tight">
              Engineering Matrix
            </h2>
            <p className="text-slate-400 max-w-xl mx-auto text-xs sm:text-sm">
              Verifiable configurations built to handle high-uptime urban and intercity routes.
            </p>
          </div>

          <div className="grid gap-3 sm:grid-cols-2">
            {specs.map((spec, i) => (
              <div
                key={i}
                className="bg-slate-900/60 backdrop-blur-md border border-slate-800/80 rounded-xl sm:rounded-2xl p-4 sm:p-5 flex justify-between items-center group"
              >
                <div>
                  <p className="text-slate-500 text-[10px] sm:text-xs font-semibold uppercase tracking-wider mb-0.5">
                    {spec.title}
                  </p>
                  <h3 className="text-sm sm:text-base font-bold text-slate-100 group-hover:text-emerald-400 transition-colors">
                    {spec.value}
                  </h3>
                </div>
                <div className="w-1 h-5 bg-slate-800 rounded-full group-hover:bg-emerald-500 transition-colors ml-3 shrink-0" />
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA SECTION */}
      <section className="py-12 sm:py-20 px-4 sm:px-6 bg-white">
        <div className="max-w-5xl mx-auto rounded-2xl sm:rounded-[2.5rem] bg-gradient-to-br from-emerald-900 via-emerald-950 to-slate-950 text-white p-6 sm:p-12 md:p-16 text-center relative overflow-hidden shadow-2xl">
          
          <div className="max-w-2xl mx-auto space-y-5 sm:space-y-6 relative z-10">
            <h2 className="text-2xl sm:text-4xl md:text-5xl font-extrabold tracking-tight leading-tight">
              Electrify Your Fleet Operations
            </h2>

            <p className="text-xs sm:text-sm md:text-base text-emerald-100/80 max-w-xl mx-auto leading-relaxed">
              Lower operational expenses, cut fleet carbon down to 0%, and scale your public or private transportation grid with reliable modern architecture.
            </p>

            <div className="flex flex-col sm:flex-row justify-center gap-3 pt-2">
              <button className="bg-emerald-500 hover:bg-emerald-400 text-slate-950 px-6 py-3.5 rounded-xl font-bold text-sm sm:text-base transition-all flex items-center justify-center gap-2">
               <FaPhoneAlt className="w-4 h-4 shrink-0" />
                Contact Corporate Sales
              </button>

              <button className="border border-white/20 bg-white/5 hover:bg-white/10 px-6 py-3.5 rounded-xl font-medium text-sm sm:text-base transition-all flex items-center justify-center gap-2">
         <FaCoins className="w-4 h-4 text-emerald-400 shrink-0" />
                Request Pricing Matrix
              </button>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ElectricBusProductPage;